import Individual from './individual/Advance';
import AdvanceLabel from 'components/organisms/forms/advance/advanceLabelForm';
import CreateAdvance from './create/CreateAdvance';
import EditAdvance from './edit/EditAdvance';

export default { Individual, AdvanceLabel, CreateAdvance, EditAdvance };
